const createProductPlaceholder = (
  text: string,
  bgColor: string,
  accentColor: string,
  emoji: string
): string => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="500" height="400" viewBox="0 0 500 400">
      <defs>
        <radialGradient id="bg_${text.replace(/\s/g, '')}" cx="50%" cy="40%" r="70%">
          <stop offset="0%" style="stop-color:${bgColor};stop-opacity:1" />
          <stop offset="100%" style="stop-color:${accentColor};stop-opacity:1" />
        </radialGradient>
      </defs>
      <rect width="500" height="400" fill="url(#bg_${text.replace(/\s/g, '')})" rx="0" ry="0"/>
      <circle cx="250" cy="160" r="80" fill="${accentColor}" opacity="0.3"/>
      <text x="250" y="180" font-size="72" text-anchor="middle" dominant-baseline="middle">${emoji}</text>
      <text x="250" y="290" font-family="Georgia, serif" font-size="22" fill="#5C3D2E" text-anchor="middle" font-weight="600">${text}</text>
      <text x="250" y="320" font-family="Arial, sans-serif" font-size="13" fill="#8B6F5E" text-anchor="middle">Artesanal</text>
    </svg>
  `.trim();

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

const createHeroPlaceholder = (): string => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600">
      <defs>
        <radialGradient id="heroGrad" cx="50%" cy="50%" r="50%">
          <stop offset="0%" style="stop-color:#F2D5D0;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#E7D4B5;stop-opacity:0.6" />
        </radialGradient>
      </defs>
      <rect width="600" height="600" fill="url(#heroGrad)" rx="300" ry="300"/>
      <circle cx="300" cy="240" r="120" fill="#C49B8A" opacity="0.2"/>
      <text x="300" y="250" font-size="120" text-anchor="middle" dominant-baseline="middle">🍬</text>
      <circle cx="420" cy="150" r="40" fill="#F2D5D0" opacity="0.5"/>
      <text x="420" y="160" font-size="40" text-anchor="middle" dominant-baseline="middle">🍪</text>
      <circle cx="180" cy="380" r="35" fill="#E7D4B5" opacity="0.5"/>
      <text x="180" y="390" font-size="36" text-anchor="middle" dominant-baseline="middle">🥥</text>
      <text x="300" y="440" font-family="Georgia, serif" font-size="20" fill="#6B4F3E" text-anchor="middle" font-weight="600" opacity="0.6">Feito com Carinho</text>
    </svg>
  `.trim();

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

const createAboutPlaceholder = (): string => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="600" height="500" viewBox="0 0 600 500">
      <defs>
        <radialGradient id="aboutGrad" cx="50%" cy="50%" r="60%">
          <stop offset="0%" style="stop-color:#F8E2E0;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#F2D5D0;stop-opacity:1" />
        </radialGradient>
      </defs>
      <rect width="600" height="500" fill="url(#aboutGrad)" rx="24" ry="24"/>
      <circle cx="300" cy="200" r="100" fill="#C49B8A" opacity="0.15"/>
      <text x="300" y="200" font-size="100" text-anchor="middle" dominant-baseline="middle">👩‍🍳</text>
      <text x="300" y="360" font-family="Georgia, serif" font-size="20" fill="#6B4F3E" text-anchor="middle" font-weight="600">Viviane</text>
      <text x="300" y="390" font-family="Arial, sans-serif" font-size="14" fill="#8B6F5E" text-anchor="middle">Artesã desde 2018</text>
    </svg>
  `.trim();

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const balaCoco = createProductPlaceholder('Bala de Coco', '#F8E2E0', '#F2D5D0', '🥥');
export const balaAmendoim = createProductPlaceholder('Bala de Amendoim', '#F5EDE3', '#E7D4B5', '🥜');
export const biscoitoAmanteigado = createProductPlaceholder('Biscoito Amanteigado', '#F8E2E0', '#F2D5D0', '🍪');
export const balaLeite = createProductPlaceholder('Bala de Leite', '#F5EDE3', '#E7D4B5', '🍬');
export const biscoitoCanela = createProductPlaceholder('Biscoito de Canela', '#F8E2E0', '#F2D5D0', '✨');
export const balaMorango = createProductPlaceholder('Bala de Morango', '#F5EDE3', '#E7D4B5', '🍓');
export const heroImage = createHeroPlaceholder();
export const aboutImage = createAboutPlaceholder();

